import { Box, ColorOptions, TextNew } from '@jfs/ui-new'
import { Colors } from '../../../../utils'
import { FAILED, FAILED_ALPHA, styles } from './styles'

const sharedBgColor = (status: string) => {
  console.log('status', status)
  const casedStatus = status?.toLowerCase()
  if (
    casedStatus === 'active' ||
    casedStatus === 'processed' ||
    casedStatus === 'approved' ||
    casedStatus === 'synced with mas' ||
    casedStatus === 'available' ||
    casedStatus === 'completed'
  ) {
    console.log('casedStatus', casedStatus)
    return { bg: 'DISMANTLED_GREEN' as ColorOptions, textColor: 'GREEN' as ColorOptions }
  } else if (
    casedStatus === 'failed' ||
    casedStatus === 'blocked' ||
    casedStatus === 'rejected' ||
    casedStatus === 'Expired'
  ) {
    return { bg: FAILED_ALPHA as ColorOptions, textColor: FAILED as ColorOptions }
  } else if (casedStatus === 'in_progress' || casedStatus === 'progress' || casedStatus === 'replaced') {
    return { bg: Colors.ORANGE_BG_C, textColor: Colors.ORANGE_C }
  } else {
    return { bg: 'BRAND_PRIMARY_RED' as ColorOptions, textColor: 'WHITE' as ColorOptions }
  }
}

interface StatusBox {
  status: string
  alignment?: 'flex-start' | 'center' | 'flex-end'
}

export const StatusBox = ({ status, alignment }: StatusBox) => {
  const statusMapper = sharedBgColor(status)
  return (
    <Box {...styles.statusBox} alignSelf={alignment} bg={statusMapper.bg}>
      <TextNew title={status} {...styles.statusText} color={statusMapper.textColor} />
    </Box>
  )
}
